import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Collapse,
  Typography,
  SvgIcon,
  styled,
  SwipeableDrawer,
  IconButton,
  Dialog
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  setActiveModule,
  toggleExpandMenu
} from '../../redux/reducers/layoutSlice';
import {
  DOWNLOAD_APP_ICON,
  IMG_SPLASH_LOGO,
  menu_dashboard_icon,
  menu_location_icon,
  menu_user_icon,
  menu_courses_icon
} from '../../utils/imageUrls';
import {
  colorLinkGrey,
  colorPrimary,
  colorSecondary
} from '../../config/theme';
import { APP_STORE_URLS, drawerWidth } from '../../utils/constant';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';
import { privateRoute } from '../../App';
import { useEffect, useState } from 'react';
import {
  BookOpenIcon,
  CalendarIcon,
  ContentSpaceIcon,
  FileSearchIcon,
  GiveFeedBackIcon,
  ResourceLibraryIcon,
  UserEditIcon,
  AnalyticsIcon
} from '../../utils/iconSvg';
import { CloseOutlined, Menu } from '@mui/icons-material';
import TourComponent from '../TourGuideComponent';
import { getMenuArray } from '../../config/cookie';
import {
  hasDashboardMenuAccess,
  hasDashboardPageDataAccess,
  isAdminRoleType
} from '../../utils/navigationMenu';

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'space-between'
}));

function SideBar({ menulist, sidebarOpen, onToggle }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isDownloadApp, setIsDownloadApp] = useState();

  const { activeMenuId, expandedMenus } = useSelector(state => state.layout);

  const isActiveMenu = currentMenu => {
    return activeMenuId === currentMenu;
  };

  const [open, setOpen] = useState({});

  const handleClick = (item, index, hasChild) => {
    if (hasChild) {
      onToggle(true);
      dispatch(toggleExpandMenu(open === index ? null : index));
    } else {
      dispatch(setActiveModule(item));
      let routeTo = privateRoute.find(cc => cc.menu_name === item);
      if (routeTo) {
        return navigate(routeTo?.path);
      } else {
        navigate('/forbidden');
      }
    }
  };

  const handleDownloadAppClick = () => {
    setIsDownloadApp(true);
  };

  const openAppStoreInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    setOpen(expandedMenus);
  }, [expandedMenus]);

  const { authData } = useSelector(state => state.auth);
  const safeMenulist = menulist && typeof menulist === 'object' ? menulist : {};
  const hasDashboardAccess =
    isAdminRoleType(authData?.roleType) ||
    hasDashboardMenuAccess(getMenuArray()) ||
    hasDashboardPageDataAccess(authData?.pageData);
  const hideLibraryInSidebar = isAdminRoleType(authData?.roleType);

  useEffect(() => {
    const token = sessionStorage.getItem('x-auth-token');
    try {
      const parsedToken = JSON.parse(token);
      if (!parsedToken || Object.keys(parsedToken).length === 0) {
        navigate('/login');
        return;
      }
    } catch (err) {
      navigate('/login');
      return;
    }

    if (!authData || !Object.keys(safeMenulist).length) {
      if (hasDashboardAccess) {
        handleClick('dashboard', 999, false);
      }
      return;
    }

    if (hasDashboardAccess) {
      handleClick('dashboard', 999, false);
      return;
    }

    let landingPage = null;

    if (authData.landingModuleId && authData.landingModuleId !== 0) {
      for (const group in safeMenulist) {
        const match = safeMenulist[group]?.find(
          item => item.pageId === authData.landingModuleId
        );
        if (match) {
          landingPage = match.pageName;
          break;
        }
      }
    }

    if (!landingPage) {
      for (const group in safeMenulist) {
        const firstItem = safeMenulist[group]?.find(item => item.status);
        if (firstItem) {
          landingPage = firstItem.pageName;
          break;
        }
      }
    }

    if (landingPage) {
      handleClick(landingPage, 0, false);
    }
  }, [authData, safeMenulist]);

  const renderSubmenus = submenus => {
    if (!submenus || typeof submenus !== 'object') {
      return null;
    }

    return (
      <>
        {Object.keys(submenus).map((group, index) => (
          <div key={index}>
            <ListItemButton
              className={
                group === 'Administration'
                  ? 'step-administration'
                  : group === 'Content Management'
                    ? 'step-content-management'
                    : ''
              }
              sx={{
                justifyContent: sidebarOpen ? '' : 'center',
                width: sidebarOpen ? '95%' : '90px',
                borderRadius: '0 8px 8px 0',
                backgroundColor: isActiveMenu(group) ? colorPrimary : 'inherit',
                '&:hover': {
                  backgroundColor: 'transparent'
                },
                fontWeight: isActiveMenu(group) ? 'bold' : 'normal'
              }}
              onClick={() => {
                handleClick(
                  group,
                  index,
                  submenus[group] && submenus[group].length > 0
                );
              }}
            >
              <ListItemIcon sx={{ minWidth: 35 }}>
                <SvgIcon>
                  {group === 'Administration' || group === 'User Management' ? (
                    menu_user_icon
                  ) : group === 'Location Management' ? (
                    menu_location_icon
                  ) : group === 'Teacher Evaluation' ? (
                    <UserEditIcon />
                  ) : group === 'Classroom Observations' ? (
                    <FileSearchIcon />
                  ) : group === 'Product Analytics' ? (
                    <AnalyticsIcon />
                  ) : group === 'Analytics' ? (
                    <AnalyticsIcon />
                  ) : group === 'Courses' ? (
                    menu_courses_icon
                  ) : group === 'Teaching Aids' ? (
                    <BookOpenIcon />
                  ) : group === 'Session Schedules' ? (
                    <CalendarIcon />
                  ) : group === 'Give Feedback' ? (
                    <GiveFeedBackIcon />
                  ) : group === 'Content Management' ? (
                    <ResourceLibraryIcon />
                  ) : group === 'Resources' ? (
                    <ContentSpaceIcon />
                  ) : (
                    ''
                  )}
                </SvgIcon>
              </ListItemIcon>
              {/* <ListItemText>
                <Typography fontWeight={'600'} fontSize={13}>
                  {group}
                </Typography>
              </ListItemText> */}
              {sidebarOpen && (
                <ListItemText>
                  <Typography fontWeight={'600'} fontSize={13}>
                    {group}
                  </Typography>
                </ListItemText>
              )}
              {sidebarOpen && (
                <>
                  {submenus[group] && submenus[group].length > 0 ? (
                    open === index ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )
                  ) : (
                    ''
                  )}
                </>
              )}
            </ListItemButton>
            <Collapse in={open == index} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {(submenus[group] || [])
                  .filter(
                    cc =>
                      cc.status &&
                      (!hideLibraryInSidebar || cc.pageName !== 'Library')
                  )
                  .map(item => (
                    <ListItemButton
                      sx={{
                        justifyContent: sidebarOpen ? '' : 'center',
                        width: sidebarOpen ? '95%' : '90px',
                        borderRadius: '0 8px 8px 0',
                        backgroundColor: isActiveMenu(item.pageName)
                          ? colorPrimary
                          : 'inherit',
                        '&:hover': {
                          backgroundColor: 'transparent'
                        },
                        fontWeight: isActiveMenu(item.pageName)
                          ? 'bold'
                          : 'normal'
                      }}
                      key={item.pageId}
                      onClick={() => handleClick(item.pageName, index, false)}
                    >
                      <ListItemIcon sx={{ minWidth: 35 }}>
                        {/* <SvgIcon>
                          {item?.pageName === 'Home' ? (
                            <ResourceHomeIcon />
                          ) : item?.pageName === 'Library' ? (
                            <ResourceLibraryIcon />
                          ) : item?.pageName === 'History' ? (
                            <ResourceHistoryIcon />
                          ) : item?.pageName === 'Favourites' ? (
                            <ResourceFavouritesIcon />
                          ) : (
                            ''
                          )}
                        </SvgIcon> */}
                      </ListItemIcon>
                      {/* <ListItemText>
                        <Typography fontWeight={'600'} fontSize={13}>
                          {item.pageName}
                        </Typography>
                      </ListItemText> */}
                      {sidebarOpen && (
                        <ListItemText>
                          <Box
                            className={
                              item?.pageName === 'Library'
                                ? 'step-library'
                                : // : item?.pageName === 'History'
                                  //   ? 'step-history'
                                  item?.pageName === 'Favourites'
                                  ? 'step-favorite'
                                  : ''
                            }
                          >
                            <Typography fontWeight={'600'} fontSize={13}>
                              {item.pageName}
                            </Typography>
                          </Box>
                        </ListItemText>
                      )}
                    </ListItemButton>
                  ))}
              </List>
            </Collapse>
          </div>
        ))}
        {/* <TourComponent sidebarOpen={sidebarOpen} /> */}
      </>
    );
  };

  const list = anchor => (
    <Box role="presentation">
      <List
        component="div"
        sx={{
          width: '100%',
          bgcolor: colorSecondary,
          maxWidth: '360px',
          overflowY: 'auto',
          // height: { lg: 'calc(100vh - 300px)' },
          height:
            authData?.tourGuideFlag && authData?.roleType === 'Admin'
              ? { lg: 'calc(100vh - 230px)' }
              : { lg: 'calc(100vh - 300px)' },

          '&::-webkit-scrollbar': {
            width: '0.0em'
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent'
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(0, 0, 0, 0.3)'
          }
        }}
      >
        {hasDashboardAccess && (
          <ListItemButton
            className="step-dashboard"
            sx={{
              justifyContent: sidebarOpen ? '' : 'center',
              width: sidebarOpen ? '95%' : '90px',
              borderRadius: '0 8px 8px 0',
              backgroundColor: isActiveMenu('dashboard')
                ? colorPrimary
                : 'inherit',
              '&:hover': {
                backgroundColor: 'transparent'
              },
              fontWeight: isActiveMenu('dashboard') ? 'bold' : 'normal'
            }}
            onClick={() => handleClick('dashboard', 999, false)}
          >
            <ListItemIcon sx={{ minWidth: 35 }}>
              <SvgIcon>{menu_dashboard_icon}</SvgIcon>
            </ListItemIcon>
            {sidebarOpen && (
              <Typography fontWeight={'600'} fontSize={13}>
                Dashboard
              </Typography>
            )}
          </ListItemButton>
        )}

        {renderSubmenus(safeMenulist)}
      </List>
    </Box>
  );

  return (
    <>
      <SwipeableDrawer
        open={true}
        onClose={() => {
          onToggle(false);
        }}
        onOpen={() => {
          onToggle(true);
        }}
        sx={{
          width: sidebarOpen ? drawerWidth : 106,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: sidebarOpen ? drawerWidth : 106,
            boxSizing: 'border-box',
            bgcolor: colorSecondary,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            border: 'none',
            zIndex: 900
          }
        }}
        variant="persistent"
        anchor="left"
      >
        <DrawerHeader
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignSelf: 'flex-start',
            marginTop: 2
          }}
        >
          <Box
            role="presentation"
            sx={{ cursor: 'pointer' }}
            onClick={() => {
              if (hasDashboardAccess) {
                navigate('/dashboard');
              } else {
                let landingPage = null;
                if (
                  authData?.landingModuleId &&
                  authData?.landingModuleId !== 0
                ) {
                  for (const group in safeMenulist) {
                    const match = safeMenulist[group]?.find(
                      item => item.pageId === authData.landingModuleId
                    );
                    if (match) {
                      landingPage = match.pageName;
                      break;
                    }
                  }
                }
                if (!landingPage) {
                  for (const group in safeMenulist) {
                    const firstItem = safeMenulist[group]?.find(
                      item => item.status
                    );
                    if (firstItem) {
                      landingPage = firstItem.pageName;
                      break;
                    }
                  }
                }

                if (landingPage) {
                  const routeTo = privateRoute.find(
                    cc => cc.menu_name === landingPage
                  );
                  if (routeTo) {
                    navigate(routeTo.path);
                  } else {
                    navigate('/forbidden');
                  }
                }
              }
            }}
          >
            <img
              style={{ margin: '15px 15px' }}
              height={sidebarOpen ? 65 : 45}
              width={sidebarOpen ? 65 : 45}
              src={IMG_SPLASH_LOGO}
              alt="IMG_SPLASH_LOGO"
            />
          </Box>

          <IconButton
            sx={{
              display: 'flex',
              padding: '0px',
              alignSelf: 'flex-start',
              mx: sidebarOpen ? 3 : 0
            }}
            onClick={() => {
              dispatch(toggleExpandMenu(null));
              onToggle(!sidebarOpen);
            }}
          >
            {sidebarOpen ? (
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5 15L7.5 10L12.5 5"
                  stroke="#1F2933"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              // <Menu />
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.5 5L12.5 10L7.5 15"
                  stroke="#1F2933"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </IconButton>
        </DrawerHeader>
        {list('left')}
        {/* {!authData?.tourGuideFlag && ( */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'self-end',
            justifyContent: 'center',
            textAlign: 'center',
            alignSelf: 'center',
            marginTop: 'auto',
            marginBottom: '10px',
            height: { lg: '80%', xl: '80%', md: '75%' },
            width: { lg: '80%', xl: '75%', md: '75%' }
          }}
        >
          {!sidebarOpen ? (
            <Box sx={{ position: 'fixed' }}>
              {/* <IconButton onClick={() => onToggle(true)} sx={{ padding: 0 }}>
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.166 18.0003H23.8327M23.8327 18.0003L17.9993 12.167M23.8327 18.0003L17.9993 23.8337"
                    stroke="#1F2933"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton> */}
            </Box>
          ) : (
            <>
              <img
                style={{
                  // height:
                  //   authData?.tourGuideFlag && authData?.roleType === 'Admin'
                  //     ? '80%'
                  //     : '100%',
                  // width:
                  //   authData?.tourGuideFlag && authData?.roleType === 'Admin'
                  //     ? '80%'
                  //     : '100%',
                  height: '203px',
                  width: '214px',
                  cursor: 'pointer'
                }}
                onClick={handleDownloadAppClick}
                src={DOWNLOAD_APP_ICON}
                alt="Download app icon"
              />
            </>
          )}
        </Box>
        {/* // )} */}
      </SwipeableDrawer>
      <Dialog
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '8px'
          }
        }}
        open={isDownloadApp}
        onClose={() => setIsDownloadApp(false)}
      >
        <Box width={'529px'} height={'338px'} padding={'40px'}>
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
          >
            <Typography fontSize={'20px'} fontWeight={700}>
              Download
            </Typography>
            <IconButton onClick={() => setIsDownloadApp(false)}>
              <CloseOutlined />
            </IconButton>
          </Box>
          <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
            <SvgIcon sx={{ height: '60px', width: '60px', marginY: '24px' }}>
              <svg
                width="61"
                height="60"
                viewBox="0 0 61 60"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.5 30.0005L30.5 40.0005M30.5 40.0005L40.5 30.0005M30.5 40.0005V17.0005C30.5 13.5238 30.5 11.7854 29.1237 9.83901C28.2093 8.54581 25.5764 6.94972 24.0069 6.73707C21.6447 6.41702 20.7477 6.88497 18.9536 7.82087C10.9583 11.9916 5.5 20.3586 5.5 30.0005C5.5 43.8076 16.6929 55.0005 30.5 55.0005C44.3071 55.0005 55.5 43.8076 55.5 30.0005C55.5 20.747 50.4725 12.6677 43 8.34508"
                  stroke="#F4C24A"
                  strokeWidth="6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </SvgIcon>
            <Typography fontSize={'24px'} fontWeight={700} marginBottom={'8px'}>
              Download Our App
            </Typography>
            <Typography
              fontSize={'16px'}
              fontWeight={600}
              color={colorLinkGrey}
              marginBottom={'16px'}
            >
              Get everything in your smart phone from now.
            </Typography>
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              alignItems={'center'}
              width={'324px'}
            >
              <Box
                component="button"
                type="button"
                onClick={() => openAppStoreInNewTab(APP_STORE_URLS.android)}
                aria-label="Download on Google Play"
                sx={{
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  p: 0,
                  display: 'flex'
                }}
              >
                <SvgIcon sx={{ height: '40px', width: '150px' }}>
                  <svg
                    width="122"
                    height="34"
                    viewBox="0 0 122 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    // xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <rect
                      width="121.671"
                      height="34"
                      transform="translate(0.150269)"
                      fill="url(#pattern0_3340_71922)"
                    />
                    <defs>
                      <pattern
                        id="pattern0_3340_71922"
                        patternContentUnits="objectBoundingBox"
                        width="1"
                        height="1"
                      >
                        <use
                          xlinkHref="#image0_3340_71922"
                          transform="scale(0.00537634 0.0185185)"
                        />
                      </pattern>
                      <image
                        id="image0_3340_71922"
                        width="186"
                        height="54"
                        xlinkHref="data:image/png;base64,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"
                      />
                    </defs>
                  </svg>
                </SvgIcon>
              </Box>

              <Box
                component="button"
                type="button"
                onClick={() => openAppStoreInNewTab(APP_STORE_URLS.ios)}
                aria-label="Download on App Store"
                sx={{
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  p: 0,
                  display: 'flex'
                }}
              >
                <SvgIcon sx={{ height: '40px', width: '150px' }}>
                  <svg
                    width="123"
                    height="35"
                    viewBox="0 0 123 35"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    // xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <rect
                      width="121.671"
                      height="34"
                      transform="translate(0.5 0.839844)"
                      fill="url(#pattern0_3340_71926)"
                    />
                    <defs>
                      <pattern
                        id="pattern0_3340_71926"
                        patternContentUnits="objectBoundingBox"
                        width="1"
                        height="1"
                      >
                        <use
                          xlinkHref="#image0_3340_71926"
                          transform="scale(0.00537634 0.0185185)"
                        />
                      </pattern>
                      <image
                        id="image0_3340_71926"
                        width="186"
                        height="54"
                        xlinkHref="data:image/png;base64,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"
                      />
                    </defs>
                  </svg>
                </SvgIcon>
              </Box>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </>
  );
}

export default SideBar;
